// src/services/settingsService.js
import apiClient from './apiClient.js'

export const settingsService = {
    getThemeSettings() {
        return apiClient.get('/settings/theme')
    },

    updateThemeSettings(data) {
        return apiClient.put('/settings/theme', data)
    },

    getEmailSettings() {
        return apiClient.get('/settings/email')
    },

    updateEmailSettings(data) {
        return apiClient.put('/settings/email', data)
    },
}